import { useContextSelector } from "use-context-selector";
import { InitializeContext } from "contexts/Initialize"

export function useInitialize() {
  return {
    isLoading: useContextSelector(InitializeContext, c => c.isLoading),
  };
}
